var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tag, _vm._b({
    tag: "component",
    staticClass: "card",
    class: [_vm.shadowString && !_vm.outlined ? 'shadow-' + _vm.shadowString : '', _vm.colorString ? 'bg-' + _vm.colorString : '', {
      'mb-8 sm:mb-16': !_vm.noSpacing
    }, _vm.responsiveGridBorderRadiusClass, {
      'is-clickable': _vm.isClickable && !_vm.disabled,
      'card-small': _vm.small,
      'card-x-small': _vm.xSmall,
      'border': _vm.outlined,
      'is-dark': _vm.dark
    }],
    style: {
      width: _vm.widthStyle,
      maxWidth: _vm.maxWidthStyle,
      minWidth: _vm.minWidthStyle,
      height: _vm.heightStyle,
      maxHeight: _vm.maxHeightStyle,
      minHeight: _vm.minHeightStyle,
      backgroundColor: _vm.colorHex
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'component', _vm.linkProps, false), [_vm.isLoading ? _c('progress-bar', {
    attrs: {
      "absolute": "",
      "top": "",
      "color": _vm.loadingColor
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }